export default class DurationTimer {
  private startTime: number | null;
  private elapsedTime: number;

  constructor() {
    this.startTime = null;
    this.elapsedTime = 0;
  }

  start() {
    if (this.startTime === null) {
      this.startTime = Date.now();
    } else {
      console.error('Timer already started.');
    }
  }

  pause() {
    if (this.startTime !== null) {
      this.elapsedTime += Date.now() - this.startTime;
      this.startTime = null;
    } else {
      console.error('Timer is not started.');
    }
  }

  stop(): number {
    const elapsedTime = this.getTime();
    this.elapsedTime = 0;
    this.startTime = null;
    return elapsedTime;
  }

  getTime(): number {
    if (this.startTime !== null) {
      return this.elapsedTime + (Date.now() - this.startTime);
    } else {
      return this.elapsedTime;
    }
  }
}
